import styled from 'styled-components';

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      margin-bottom: 10px;
      h4 { width: 65px; }
   }
   .textInput {
      margin-bottom: 10px;
      h4 { width: 85px; }

      &:last-of-type {
         margin-bottom: 0;
      }
   }
   .textarea {
      margin-top: 30px;

      &:last-of-type {
         margin-top: 25px;
      }
      > div {
         height: 100px;
         min-height: 100px;
      }
   }
`;